import React, { useCallback, useEffect } from "react";
import { ReactNode } from "react";

import { setWorkspacesAction } from "@main/context/App/App.actions";
import { useAppContext, useAppDispatch } from "@main/context/App/App.context";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import { setUserTokenAction } from "@main/context/Auth/Auth.actions";
import { useAuthDispatch } from "@main/context/Auth/Auth.context";

import { UserToken } from "../models";
import ApiService from "../services/Api.service";

interface Props {
  children: ReactNode;
}

const apiService = ApiService.getInstance();

const apiProviderContext = React.createContext(apiService);

export const APIProvider = ({ children }: Props) => {
  const authDispatch = useAuthDispatch();
  const appDispatch = useAppDispatch();
  const { workspaces } = useAppContext();
  const { selectedWorkspace } = useAppSelectionContext();

  const renewTokenHandler = useCallback(
    (userToken: UserToken) => {
      authDispatch(setUserTokenAction(userToken));
    },
    [authDispatch],
  );

  const handle402PaymentRequired = useCallback(() => {
    if (!selectedWorkspace?.is_data_available) return;
    appDispatch(
      setWorkspacesAction(
        workspaces.map((w) => (w.id === selectedWorkspace.id ? { ...w, is_data_available: false } : w)),
      ),
    );
  }, [appDispatch, workspaces, selectedWorkspace]);

  useEffect(() => {
    apiService.injectRenewTokenHandler(renewTokenHandler);
  }, [renewTokenHandler]);

  useEffect(() => {
    apiService.inject402ErrorHandler(handle402PaymentRequired);
  }, [handle402PaymentRequired]);

  return <apiProviderContext.Provider value={apiService}>{children}</apiProviderContext.Provider>;
};
